<template>
  <Slideout
    :title="slideOutHeaders[currentStep]"
    position="right"
    @close-slideout="onCloseSlideout"
  >
    <div class="add-to-wishlist">
      <div v-if="currentStep === 'inProgres'">
        <p>Loading...</p>
      </div>
      <StepConfirmation
        v-else-if="currentStep === 'confrimedSignedIn' || currentStep === 'confrimedNotSignedIn'"
        :product="productData"
        :is-add-to-wishlist-success="isAddToWishlistSuccess"
        :is-multiple="isMultiple"
        :selected-upc-id="selectedUpcId"
        :is-signed-in="isSignedIn"
        @close-slideout="onCloseSlideout"
      />
      <StepSelect
        v-else-if="currentStep === 'selectSize' || currentStep === 'selectColor' || currentStep === 'selectSizeColor'"
        :product="productData"
        @addToWishListSuccess="processSuccess"
        @addToWishListError="processError"
      >
        <template #product-thumbnail="slotProps">
          <div v-if="slotProps.product">
            <slot
              name="step-select"
              :product="slotProps.product"
              :url-template="slotProps.urlTemplate"
              :updateUpcId="slotProps.updateUpcId"
            />
          </div>
        </template>
      </StepSelect>
    </div>
  </Slideout>
</template>

<script>
import { Slideout } from '@atomic-ui/slideout';
import { productXapiFetchLarge, addToWishList } from '../services/api';
import StepSelect from './StepSelect';
import StepConfirmation from './StepConfirmation';

export default {
  name: 'AddToWishlistDrawer',
  components: {
    Slideout, StepSelect, StepConfirmation,
  },
  props: {
    product: {
      type: Object,
      default: undefined,
    },
    productId: {
      type: Number,
      default: undefined,
    },
  },
  emits: ['wishlist-drawer-close', 'product-is-added'],
  data() {
    return {
      currentStep: 'inProgres',
      isSignedIn: true,
      productData: undefined,
      isMultiple: undefined,
      selectedUpcId: undefined,
      isAddToWishlistSuccess: undefined,
      slideOutHeaders: {
        inProgres: '',
        confrimedSignedIn: 'Saved to your wish list',
        confrimedNotSignedIn: 'Saved to your temporary wish list',
        selectSize: 'Select a size',
        selectColor: 'Select a color',
        selectSizeColor: 'Select a size & color',
      },
    };
  },
  watch: {
    async productId(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentStep = 'inProgres';
        this.productData = await this.getProductLargeData(this.productId);
        this.isMultiple = Object.keys(this.productData?.relationships?.upcs).length > 1;
      }
    },
    isMultiple(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue === true) {
          this.currentStep = this.getStepSelectVariant();
        }
        if (newValue === false) {
          this.addProductToWishList(this.productId);
        }
      }
    },
  },
  async mounted() {
    if (!this.product && this.productId) {
      this.productData = await this.getProductLargeData(this.productId);
      this.isMultiple = Object.keys(this.productData?.relationships?.upcs || {}).length > 1;
    }
  },
  methods: {
    async getProductLargeData(productId) {
      let productData = {};
      if (productId) productData = await productXapiFetchLarge(productId);

      return productData;
    },
    addProductToWishList(id) {
      this.currentStep = this.isSignedIn ? 'confrimedSignedIn' : 'confrimedNotSignedIn';
      addToWishList(id,
        (response) => {
          this.isAddToWishlistSuccess = true;
          this.$store.commit('wishlistStore/addToWishlist', { productId: id, response: response.data });
          this.$emit('product-is-added');
        },
        () => {
          this.isAddToWishlistSuccess = false;
        });
    },
    processSuccess({ product, response }) {
      if (product.upcId) {
        this.selectedUpcId = product.upcId;
      }
      // to store product_id and list_guid and user guid
      this.$store.commit('wishlistStore/addToWishlist', { productId: this.productId, response: response.data });

      this.$emit('product-is-added');
      this.currentStep = this.isSignedIn ? 'confrimedSignedIn' : 'confrimedNotSignedIn';
    },

    processError(product) {
      if (product.upcId) {
        this.productData = product;
      }
    },
    getStepSelectVariant() {
      let stepName = 'selectSizeColor';
      const isMultipleColors = Object.keys(this.productData?.traits?.colors?.colorMap || {}).length > 1;
      const isMultipleSizes = Object.keys(this.productData?.traits?.sizes?.sizeMap || {}).length > 1;

      if (isMultipleColors && !isMultipleSizes) {
        stepName = 'selectColor';
      } else if (!isMultipleColors && isMultipleSizes) {
        stepName = 'selectSize';
      }

      return stepName;
    },
    onCloseSlideout() {
      this.$emit('wishlist-drawer-close');
    },
  },
};
</script>

<style lang="scss" brand="bcom" scoped>
:deep(.button-wrap) {
  display: flex;
  flex-direction: column;
  gap: rem-calc(22);
}
</style>
